import clsx from "clsx";
import * as React from "react";

import * as PropTypes from "../prop-types";
import { PropsType } from "../PropsType";
import { spsGlobalPropTypes } from "../util";

export const propTypes = {
    ...spsGlobalPropTypes,
    resultsCount: PropTypes.number,
    totalResults: PropTypes.number,
    onClear: PropTypes.func
};

export type SpsSearchResultsBarProps = PropsType<typeof propTypes> & React.HTMLAttributes<HTMLDivElement>;

function SpsSearchResultsBar(props: SpsSearchResultsBarProps) {
    const {
        children,
        className,
        resultsCount,
        totalResults,
        onClear,
        "data-testid": testId,
        unsafelyReplaceClassName,
        ...rest
    } = props;

    const classes = clsx(
        unsafelyReplaceClassName || "sps-search-results-bar",
        className
    );

    return (
        <div className={classes} data-testid={`${testId}`} {...rest} >
            <span className="sps-search-results-bar__label" data-testid={`${testId}__label`}>Matching results</span>
            {
                resultsCount &&
                <span className="sps-search-results-bar__count" data-testid={`${testId}__count`}>
                    <i className="sps-icon sps-icon-double-angle-right"></i>
                    <span>{resultsCount}</span>
                </span>
            }
            {
                totalResults &&
                <span className="sps-search-results-bar__total" data-testid={`${testId}__total`}>of {totalResults}</span>
            }
            <div className="sps-search-results-bar__buttons" data-testid={`${testId}__button`}>
                <button onClick={onClear}>Clear</button>
            </div>
        </div >
    );
}

Object.assign(SpsSearchResultsBar, {
    propTypes,
    displayName: "SpsSearchResultsBar"
});

export {SpsSearchResultsBar};